import axios from 'axios';

export function postRequestVessel(vesselRequest) {
    return axios({
        method: 'POST',
        url: '/api/v1/requests/vessel',
        data: vesselRequest,
        params: {
            wrapper: vesselRequest.clientVessel ? 'email_wrapper' : undefined,
        },
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function getVesselMonitor(filter) {
    return axios({
        method: 'post',
        url: '/api/v1/requests/vessels',
        withCredentials: true,
        data: {
            page: filter.page || 1,
            filters: filter.filters || {},
            sort: filter.sort || {},
        },
    })
        .then(response => response.data)
        .catch(response => response.data);
}

export function changeUserVesselRequest(vesselRequestId, userId) {
    return axios({
        method: 'put',
        url: `/api/v1/requests/vessel/${vesselRequestId}/changeOwner`,
        withCredentials: true,
        data: {
            user: userId,
        },
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}

export function deleteVesselRequest(vesselId, requestId) {
    return axios({
        method: 'delete',
        url: `/api/v1/vessels/position/${vesselId}/${requestId}`,
        withCredentials: true,
    })
        .then(response => response.data)
        .catch(response => response.response.data);
}



// WEBPACK FOOTER //
// ./app/services/vessels/requests.js